var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistrar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.99 123.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5ef3b;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22{fill-rule:evenodd;}.cls-2{fill:#e3dd2b;}.cls-3{fill:#fff;}.cls-4,.cls-23{fill:#31b8bd;}.cls-5{fill:#e68913;}.cls-6{fill:#030e8a;}.cls-7{fill:#8bdcdf;}.cls-8{fill:#5cc5c9;}.cls-9{fill:#f5d5f1;}.cls-10{fill:#e6afdf;}.cls-11{fill:#00abdd;}.cls-24,.cls-15{fill:#68d1d1;}.cls-12{fill:#19989c;}.cls-13{fill:#ffb43f;}.cls-14{fill:#f2f2f2;}.cls-16{fill:#bff3f5;}.cls-17{fill:#6c289c;}.cls-18{fill:#1b3cb3;}.cls-19{fill:#803cb0;}.cls-20{fill:#d1cb2a;}.cls-21{fill:#1993bd;}.cls-22{fill:#ff9e23;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.38 59.28 117.15 88.72 130.38 88.74 143.61 88.72 130.38 59.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "134.61 76.79 139.59 83.54 140.18 81.09 130.38 59.28 119.86 82.71 122.99 80.42 123.61 85.09 129.21 78.66 133.05 86.03 134.61 76.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "136.03 71.85 132.88 68.72 132.88 74.98 130.83 68.72 129.03 75.83 128.54 67.23 124.53 72.3 130.38 59.28 136.03 71.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "181.19 41.5 190.98 32.38 190.98 83.79 181.19 83.79 181.19 41.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 162.02,
    y: 41.5,
    width: 19.17,
    height: 42.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "162.02 41.5 171.81 32.38 190.98 32.38 181.19 41.5 162.02 41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M177.05,47.23v-2.15h2.15v2.15h-2.15Zm0,4.05v-2.15h2.15v2.15h-2.15Zm0,4.18v-2.15h2.15v2.15h-2.15Zm0,3.92v-2.15h2.15v2.15h-2.15Zm0,4.18v-2.15h2.15v2.15h-2.15Zm0,8.22v-2.15h2.15v2.15h-2.15Zm0-4.18v-2.15h2.15v2.15h-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M172.95,47.23v-2.15h2.15v2.15h-2.15Zm0,4.05v-2.15h2.15v2.15h-2.15Zm0,4.18v-2.15h2.15v2.15h-2.15Zm0,3.92v-2.15h2.15v2.15h-2.15Zm0,4.18v-2.15h2.15v2.15h-2.15Zm0,8.22v-2.15h2.15v2.15h-2.15Zm0-4.18v-2.15h2.15v2.15h-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M168.85,47.23v-2.15h2.15v2.15h-2.15Zm0,4.05v-2.15h2.15v2.15h-2.15Zm0,4.18v-2.15h2.15v2.15h-2.15Zm0,3.92v-2.15h2.15v2.15h-2.15Zm0,4.18v-2.15h2.15v2.15h-2.15Zm0,8.22v-2.15h2.15v2.15h-2.15Zm0-4.18v-2.15h2.15v2.15h-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M164.75,47.23v-2.15h2.15v2.15h-2.15Zm0,4.05v-2.15h2.15v2.15h-2.15Zm0,4.18v-2.15h2.15v2.15h-2.15Zm0,3.92v-2.15h2.15v2.15h-2.15Zm0,4.18v-2.15h2.15v2.15h-2.15Zm0,8.22v-2.15h2.15v2.15h-2.15Zm0-4.18v-2.15h2.15v2.15h-2.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "144.42 44.7 159.96 44.7 160.71 49.28 159.52 49.28 159.52 88.16 144.99 88.16 144.99 49.28 143.91 49.28 144.42 44.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 50.16,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 50.16,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 52.04,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 52.04,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 54.93,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 54.93,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 56.81,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 56.81,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 59.7,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 59.7,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 61.58,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 61.58,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 64.47,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 64.47,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 66.35,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 66.35,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 69.24,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 69.24,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 71.12,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 71.12,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 74.01,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 74.01,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 75.89,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 75.89,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 78.78,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 78.78,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 155.91,
    y: 80.66,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 152.97,
    y: 80.66,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 50.16,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 50.16,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 52.04,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 52.04,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 54.93,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 54.93,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 56.81,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 56.81,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 59.7,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 59.7,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 61.58,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 61.58,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 64.47,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 64.47,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 66.35,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 66.35,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 69.24,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 69.24,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 71.12,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 71.12,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 74.01,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 74.01,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 75.89,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 75.89,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 78.78,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 78.78,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 149.55,
    y: 80.66,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 146.61,
    y: 80.66,
    width: 2.12,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 141.55,
    y: 63.1,
    width: 1.59,
    height: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 138.17,
    y: 68.78,
    width: 1.59,
    height: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 141.55,
    y: 68.78,
    width: 1.59,
    height: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 138.17,
    y: 74.59,
    width: 1.59,
    height: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 141.55,
    y: 74.59,
    width: 1.59,
    height: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 138.17,
    y: 80.27,
    width: 1.59,
    height: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 141.55,
    y: 80.27,
    width: 1.59,
    height: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 178.97,
    y: 63.97,
    width: 10.39,
    height: 25.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "167.9 56.11 178.97 63.97 178.97 89.04 156.89 89.04 156.89 63.97 156.84 63.97 167.9 56.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "190.13 63.97 178.97 63.97 167.9 54.72 178.58 54.72 190.13 63.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "178.97 63.97 167.9 56.11 156.84 63.97 155.48 63.97 167.9 54.72 180.28 63.97 178.97 63.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 172.17,
    y: 64.87,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 165.91,
    y: 64.87,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 159.66,
    y: 64.87,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 172.17,
    y: 72.29,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 165.91,
    y: 72.29,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 159.66,
    y: 72.29,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 172.17,
    y: 79.71,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 165.91,
    y: 79.71,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 159.66,
    y: 79.71,
    width: 4.76,
    height: 6.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "202.84 47.1 191.26 47.1 185.89 54.86 195.96 54.86 202.84 47.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 187.12,
    y: 54.86,
    width: 9.8,
    height: 34.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "207.63 83.88 207.84 83.51 205.34 83.51 208.04 78.83 208.73 77.63 206.4 77.64 208.57 73.87 210.75 70.1 212.92 73.87 215.1 77.63 212.76 77.63 213.45 78.82 216.15 83.5 213.65 83.5 213.87 83.87 216.99 89.28 210.75 89.28 204.51 89.28 207.63 83.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "196.92 54.86 202.82 48.2 208.73 54.86 208.73 89.32 196.92 89.32 196.92 54.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "209.72 54.86 208.73 54.86 202.82 48.2 196.92 54.86 195.96 54.86 202.84 47.1 209.72 54.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.87,79.25h-2.62v-5.08h2.62v5.08h0Zm0,6.22h-2.62v-5.08h2.62v5.08h0Zm3.39-24.88h-2.62v-5.08h2.62v5.08h0Zm-3.39-5.08v5.08h-2.62v-5.08h2.62Zm3.39,11.3h-2.62v-5.08h2.62v5.08h0Zm-3.39,0h-2.62v-5.08h2.62v5.08h0Zm0,6.22h-2.62v-5.08h2.62v5.08h0Zm6.73,0h-2.62v-5.08h2.62v5.08h0Zm0,6.22h-2.62v-5.08h2.62v5.08h0Zm0,6.22h-2.62v-5.08h2.62v5.08h0Zm0-18.66h-2.62v-5.08h2.62v5.08h0Zm-3.34,18.66h-2.62v-5.08h2.62v5.08h0Zm0-12.44h-2.62v-5.08h2.62v5.08h0Zm0,6.22h-2.62v-5.08h2.62v5.08h0Zm3.34-18.66h-2.62v-5.08h2.62v5.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "145.46 60.9 136.09 64.05 136.09 88.4 145.46 88.4 145.46 60.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "145.46 60.9 145.46 61.68 136.09 64.83 136.09 64.05 145.46 60.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 142.28,
    y: 65.89,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 140.16,
    y: 65.89,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 138.04,
    y: 65.89,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 142.28,
    y: 71.26,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 140.16,
    y: 71.26,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 138.04,
    y: 71.26,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 142.28,
    y: 76.63,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 140.16,
    y: 76.63,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 138.04,
    y: 76.63,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 142.28,
    y: 82,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 140.16,
    y: 82,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 138.04,
    y: 82,
    width: 1.55,
    height: 4.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.98,72.27c.14-.14,.29-.27,.44-.39-.11-.32-.18-.66-.18-1.02,0-1.7,1.38-3.08,3.08-3.08s3.08,1.38,3.08,3.08c0,.34-.06,.67-.16,.98,.17,.13,.33,.27,.49,.43,.94,.94,1.4,2.06,1.4,3.38s-.47,2.46-1.4,3.39c-.93,.93-2.05,1.39-3.38,1.39s-2.44-.46-3.38-1.39c-.93-.94-1.39-2.07-1.39-3.39s.46-2.44,1.39-3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M187.18,89.27c.09,0,.16-.07,.16-.16v-9.94l3.27-3.39c.06-.06,.06-.16,0-.22-.06-.06-.16-.06-.22,0l-1.65,1.72-1.39,1.43v-6.52l1-1c.06-.06,.06-.16,0-.22s-.16-.06-.22,0l-.78,.78v-1.04c0-.09-.07-.16-.16-.16s-.16,.07-.16,.16v5.15l-2.28-2.16c-.06-.06-.16-.06-.22,0-.06,.06-.06,.16,0,.22l.7,.66h-1.16c-.09,0-.16,.07-.16,.16,0,.09,.07,.16,.16,.16h1.49l1.46,1.38v12.82c0,.09,.07,.16,.16,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.96,89.01c0-1.06,.86-1.92,1.92-1.92,.03,0,.07,0,.1,0-.06-.15-.1-.32-.1-.5,0-.73,.59-1.33,1.33-1.33,.32,0,.61,.11,.84,.3,.36-.7,1.09-1.17,1.93-1.17,.72,0,1.37,.35,1.76,.9,.5-.43,1.15-.69,1.86-.69,1.57,0,2.84,1.27,2.84,2.84,0,.16-.01,.33-.04,.48,.04,0,.09,0,.13,0,.98,0,1.77,.79,1.77,1.77h-14.21c-.08-.21-.13-.44-.13-.68Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.3,103.67c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.75,104.45c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.13,107.89h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0c0-.1,0-.61,0-1.21,0,.6,0,1.11,0,1.21h0Zm-.17-2.22c-.25-.37-.41-.69-.51-1.05,.04,.13,.09,.26,.15,.39,.09,.21,.2,.42,.34,.62l.03,.04h0Zm-.65-2.03c-.03-.64,0-1.47-.01-2.7,0,.7,0,2.08,.01,2.7h0Zm-.01-3.01v-.07h0v.07h0Zm.33-1.6c0-1.19-.02-1.88,0-2.35v.04c0,.24,0,1.41,0,2.31h0Zm.16-3.67c0-1.11-.04-1.88,0-2.5,0,.1,0,1.51,0,2.5h0Zm.17-3.58c.08-.26,.2-.51,.36-.78-.15,.26-.28,.52-.36,.78h0Zm.48-.97c0-.36,0-.72,0-1.04h0c0,.31,0,.68,0,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.41,108.94c-.15-.35-.25-.7-.28-1.05h0c0-.11,0-.62,0-1.22,0-.26,0-.53,0-.79,.09,.12,.19,.24,.29,.36v2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.28,110.24c-.2-.22-.38-.45-.53-.68v-2.97l.04,.04c.11,.11,.23,.21,.35,.31,.04,.05,.09,.1,.14,.15v3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.62,96.71v-.04h0v.02h0v.02h0Zm.02-.35c.02-.28,.07-.49,.15-.75,0,.11,0,.22,0,.31-.08,.11-.13,.25-.16,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.08,95.7v-1.5c.09,.21,.21,.42,.34,.62v.79c-.13,.02-.24,.05-.34,.09h0Zm.87-.15v-.05s.03,.03,.05,.05h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69,95.55s-.03-.03-.05-.05v-1.11c.09,.18,.2,.35,.33,.53v.61c-.1,0-.19,.02-.29,.02h0Zm-.57-.73c-.13-.21-.25-.41-.34-.62v-1.96c0-.07-.04-.13-.11-.16-.07,.09-.12,.2-.15,.34,.03-.23,.07-.44,.14-.65,.09-.26,.21-.52,.36-.78,.04-.06,.08-.12,.12-.18h0c0,.77,0,1.5,.01,1.54,.01,.12,.03,.23,.05,.35-.05,.04-.09,.09-.09,.15v1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.82,95.48v-.56c.1,.1,.21,.21,.33,.31v.21c-.11,.02-.22,.03-.33,.05h0Zm-.53-.55c-.13-.17-.24-.35-.33-.53v-.58c.1,.17,.21,.33,.33,.5v.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.68,95.32v-1.26c0-.1-.09-.18-.21-.2v-1.51c.1,.08,.21,.17,.33,.25v2.69s-.08,.02-.12,.03h0Zm-.54-.1c-.11-.1-.22-.2-.33-.31v-1.46c0-.1-.09-.18-.21-.2v-1.7c.1,.11,.21,.23,.33,.34v3.14c.07,.06,.13,.13,.2,.19h0Zm1.41-.15v-.39c0-.1-.09-.18-.21-.2v-1.5c.1,.07,.21,.13,.32,.19v1.87s-.07,.03-.11,.04h0Zm.66-.64v-.97c.06,.03,.13,.07,.2,.1-.05,.18-.12,.48-.2,.87h0Zm-2.92-.13c-.12-.16-.23-.33-.33-.5v-.96c0-.1-.09-.18-.21-.2v-2.4c.09,.21,.2,.42,.34,.62v3.14c.06,.1,.13,.19,.2,.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68.39,120.92c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.88,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.72,112.02c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.17,112.79c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.03,113.4c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.89,114.01c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.75,114.62c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.6,115.23c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.18-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.46,115.84c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.32,116.45c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.18,121.69v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.29,122.01v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.39,122.28v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.5,122.5v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.6,122.67v-5.1c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.71,122.81v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.81,122.9v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.92,122.96v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.02,122.99v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.15,122.98v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.27,122.93v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.4,122.85v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.52,122.72v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.64,122.56v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.77,122.36v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.89,122.1v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.02,121.79v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.82,116.46c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.63,115.9c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.44,115.34c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.24,114.77c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.18,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.05,114.21c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.85,113.65c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.66,113.08c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.19,117.87c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.85,117.53c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.03,116.72c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0s4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M66.03,109.34c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.45,114.17l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M56.45,113.79l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M67.57,116.97c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.81,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.9,108.07c.06,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.35,108.84c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.21,109.45c0-.11,.11-.2,.24-.2h.02c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.07,110.06c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.93,110.67c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.79,111.28c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.7h-.02c-.18-.09-.36-.18-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.65,111.89c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.5,112.5c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.36,117.74v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.47,118.06v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.57,118.33v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.68,118.55v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.78,118.72v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.89,118.85v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.99,118.95v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.1,119.01v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.2,119.04v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.33,119.03v-5.03c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.45,118.98v-5.12c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.58,118.9v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.7,118.77v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.83,118.61v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.95,118.41v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.08,118.15v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.2,117.84v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.01,112.51c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.81,111.95c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.62,111.38c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.3c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.42,110.82c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.18,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.23,110.26c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.04,109.7c0-.11,.11-.2,.24-.2h.02c.15,0,.26,.09,.26,.2v5.39c-.16,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.84,109.13c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.65,113.79v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.15,0,.03,0,.07,.01,.1v3.34c0,.16,0,.26,0,.28-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.57,113.82c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.03,113.58c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.22,112.77c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M65.22,105.39c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.67-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.63,110.22l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M55.63,109.84l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M67.9,113.14c-6.14,2.76-16.11,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.23,104.24c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.68,105.02c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.54,105.63c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.39,106.24c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.25,106.85c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.11,107.46c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.97,108.06c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.83,108.67c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.69,113.92v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.8,114.24v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.9,114.5v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.01,114.72v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.11,114.9v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.22,115.03v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.32,115.13v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.43,115.19v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.53,115.21v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.66,115.2v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.78,115.16v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.9,115.07v-5.16c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.03,114.95v-5.17c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.15,114.79v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.28,114.58v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.4,114.33v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.53,114.02v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.33,108.69c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.21v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.14,108.12c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.95,107.56c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.75,107c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.56,106.44c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.36,105.87c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.17,105.31c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.98,109.96v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.07,.01,.11v3.3c0,.18,0,.29,0,.31-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.9,110c-6.14,2.76-16.11,2.76-22.25,0s-6.14-7.24,0-10c6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.36,109.76c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.54,108.94c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M65.54,101.56c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.67,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.14-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.95,106.4l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M55.95,106.02l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68.06,109.32c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.39,100.42c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05,0-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.84,101.19c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.7,101.8c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.56,102.41c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.42,103.02c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.28,103.63c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.14,104.24c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,104.85c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.85,110.09v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.96,110.41v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.06,110.68v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.17,110.9v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.27,111.07v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.38,111.21v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.48,111.3v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.59,111.36v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.7,111.39v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.82,111.38v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.94,111.33v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.07,111.25v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.19,111.13v-5.17c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.32,110.96v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.44,110.76v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.57,110.5v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.69,110.19v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.5,104.86c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.3,104.3c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.11,103.74c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.92,103.17c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.72,102.61c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.53,102.05c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.33,101.49c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.14,106.14v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.03,0,.07,.01,.11v3.33c0,.16,0,.26,0,.28-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.06,106.18c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.53,105.94c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.71,105.12c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M65.71,97.74c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.67-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.12,102.57l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M56.12,102.19l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68.72,105.37c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68,0-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.05,96.47c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.5,97.24c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.35,97.85c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.21,98.46c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.07,99.07c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.93,99.68c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.79,100.29c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.65,100.9c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.51,106.14v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.61,106.46v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.72,106.73v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.82,106.95v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.93,107.12v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.04,107.26v-5.11c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.14,107.35v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.24,107.41v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.35,107.44v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.47,107.43v-5.03c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.6,107.38v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.72,107.3v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.85,107.17v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.97,107.01v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.1,106.81v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.22,106.55v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.35,106.24v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.15,100.91c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.96,100.35c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.76,99.79c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.57,99.22c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.38,98.66c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.18,98.1c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.99,97.53c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.79,102.19v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.08,.01,.12v3.29c0,.18,0,.3,0,.31-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.72,102.23c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.18,101.98c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.36,101.17c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M66.36,93.79c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.77,98.62l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M56.77,98.24l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68.22,101.59c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.56,92.69c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42,93.46c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.86,94.07c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.72,94.68c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.58,95.29c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.44,95.9c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.3,96.51c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.16,97.12c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.1,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.02,102.36v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.12,102.68v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.23,102.95v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.33,103.17v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.44,103.34v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.54,103.47v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.65,103.57v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.75,103.63v-5.01c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.86,103.66v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.98,103.64v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.11,103.6v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.23,103.52v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.36,103.39v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.48,103.23v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.61,103.03v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.73,102.77v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.85,102.46v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.66,97.13c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.21v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.47,96.57c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.27,96c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.3c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.08,95.44c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.89,94.88c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.69,94.32c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.16,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.5,93.75c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.3,98.41v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.07,.01,.11v3.34c0,.16,0,.25,0,.27-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.22,98.44c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.69,98.2c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M65.87,97.39c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.87,90.01c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M56.28,94.84l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.28,94.46l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.04,111.38c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.49,112.15c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.87,115.6h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0c0-.1,0-.61,0-1.21,0,.6,0,1.11,0,1.21h0Zm-.17-2.22c-.25-.37-.41-.69-.51-1.05,.04,.13,.09,.26,.15,.39,.09,.21,.2,.42,.34,.62l.03,.04h0Zm-.65-2.03c-.03-.64,0-1.47-.01-2.7,0,.7,0,2.08,.01,2.7h0Zm-.01-3.01v-.07h0v.07h0Zm.33-1.6c0-1.19-.02-1.88,0-2.35v.04c0,.24,0,1.41,0,2.31h0Zm.16-3.67c0-1.11-.04-1.88,0-2.5,0,.1,0,1.51,0,2.5h0Zm.17-3.58c.08-.26,.2-.51,.36-.78-.15,.26-.28,.52-.36,.78h0Zm.48-.97c0-.36,0-.72,0-1.04h0c0,.31,0,.68,0,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.15,116.65c-.15-.35-.25-.7-.28-1.05h0c0-.11,0-.62,0-1.22,0-.26,0-.53,0-.79,.09,.12,.19,.24,.29,.36v2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.02,117.95c-.2-.22-.38-.45-.53-.68v-2.97l.04,.04c.11,.11,.23,.21,.35,.31,.04,.05,.09,.1,.14,.15v3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.36,104.42v-.04h0v.02h0v.02h0Zm.02-.35c.02-.28,.07-.49,.15-.75,0,.11,0,.22,0,.31-.08,.11-.13,.25-.16,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.82,103.41v-1.5c.09,.21,.21,.42,.34,.62v.79c-.13,.02-.24,.05-.34,.09h0Zm.87-.15v-.05s.03,.03,.05,.05h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.74,103.26s-.03-.03-.05-.05v-1.11c.09,.18,.2,.35,.33,.53v.61c-.1,0-.19,.02-.29,.02h0Zm-.57-.73c-.13-.21-.25-.41-.34-.62v-1.96c0-.07-.04-.13-.11-.16-.07,.09-.12,.2-.15,.34,.03-.23,.07-.44,.14-.65,.09-.26,.21-.52,.36-.78,.04-.06,.08-.12,.12-.18h0c0,.77,0,1.5,.01,1.54,.01,.12,.03,.23,.05,.35-.05,.04-.09,.09-.09,.15v1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.55,103.18v-.56c.1,.1,.21,.21,.33,.31v.21c-.11,.02-.22,.03-.33,.05h0Zm-.53-.55c-.13-.17-.24-.35-.33-.53v-.58c.1,.17,.21,.33,.33,.5v.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.42,103.03v-1.26c0-.1-.09-.18-.21-.2v-1.51c.1,.08,.21,.17,.33,.25v2.69s-.08,.02-.12,.03h0Zm-.54-.1c-.11-.1-.22-.2-.33-.31v-1.46c0-.1-.09-.18-.21-.2v-1.7c.1,.11,.21,.23,.33,.34v3.14c.07,.06,.13,.13,.2,.19h0Zm1.41-.15v-.39c0-.1-.09-.18-.21-.2v-1.51c.1,.07,.21,.13,.32,.19v1.87s-.07,.03-.11,.04h0Zm.66-.64v-.97c.06,.03,.13,.07,.2,.1-.05,.18-.12,.48-.2,.87h0Zm-2.92-.13c-.12-.16-.23-.33-.33-.5v-.96c0-.1-.09-.18-.21-.2v-2.4c.09,.21,.2,.42,.34,.62v3.14c.06,.1,.13,.19,.2,.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.31,121.53c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.77,121.29c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.95,120.47c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M105.95,113.1c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.67-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.37,117.93l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M96.37,117.55l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M108.64,120.85c-6.14,2.76-16.11,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.81,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.97,111.95c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.41,112.73c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.27,113.34c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.13,113.95c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.99,114.55c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.85,115.16c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.71,115.77c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.57,116.38c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.43,121.63v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.53,121.95v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.64,122.21v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.74,122.43v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.85,122.6v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.95,122.74v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.06,122.83v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.16,122.9v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.27,122.92v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.39,122.91v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.52,122.86v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.64,122.78v-5.16c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.77,122.66v-5.17c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.89,122.5v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.02,122.29v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.14,122.04v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.27,121.73v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.07,116.4c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.21v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.88,115.83c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.68,115.27c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.49,114.71c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.3,114.14c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.1,113.58c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.91,113.02c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.72,117.67v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.07,.01,.11v3.3c0,.18,0,.29,0,.31-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.64,117.71c-6.14,2.76-16.11,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.1,117.47c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.28,116.65c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M106.28,109.27c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.67,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.14-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.69,114.11l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M96.69,113.73l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M108.8,117.03c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.13,108.13c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05,0-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.58,108.9c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.44,109.51c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.3,110.12c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.16,110.73c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.02,111.34c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.87,111.95c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.73,112.56c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.59,117.8v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.7,118.12v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.8,118.39v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.91,118.61v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.01,118.78v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.12,118.91v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.22,119.01v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.33,119.07v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.43,119.1v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.56,119.09v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.68,119.04v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.81,118.96v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.93,118.83v-5.17c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.06,118.67v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.18,118.47v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.31,118.21v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.43,117.9v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.24,112.57c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.38,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.04,112.01c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.85,111.45c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.65,110.88c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.46,110.32c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.27,109.76c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.07,109.19c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.88,113.85v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.03,0,.07,.01,.11v3.33c0,.16,0,.26,0,.28-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.8,113.88c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.26,113.64c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.45,112.83c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M106.45,105.45c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.67-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.86,110.28l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M96.86,109.9l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M109.45,113.08c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68,0-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.79,104.18c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.23,104.95c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.09,105.56c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.95,106.17c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.81,106.78c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.67,107.39c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.53,108c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.39,108.61c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.25,113.85v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.35,114.17v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.46,114.44v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.56,114.66v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.67,114.83v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.77,114.96v-5.11c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.88,115.06v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.98,115.12v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.09,115.15v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.21,115.13v-5.03c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.34,115.09v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.46,115.01v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.59,114.88v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.71,114.72v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.84,114.51v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.96,114.26v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.08,113.95v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.89,108.62c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.7,108.06c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.5,107.49c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.31,106.93c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.12,106.37c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.92,105.81c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.73,105.24c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.53,109.9v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.08,.01,.12v3.29c0,.18,0,.3,0,.31-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.45,109.93c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.92,109.69c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.1,108.88c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M107.1,101.5c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.51,106.33l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M97.51,105.95l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M108.96,109.29c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.81,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.3,100.4c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.74,101.17c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.6,101.78c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.46,102.39c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.32,103c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.18,103.61c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.04,104.22c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.9,104.83c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.1,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.76,110.07v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.86,110.39v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.97,110.66v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.07,110.87v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.18,111.05v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.28,111.18v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.39,111.28v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.49,111.34v-5.01c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.6,111.36v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.72,111.35v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.85,111.31v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.97,111.22v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.1,111.1v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.22,110.94v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.34,110.73v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.47,110.48v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.59,110.17v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.4,104.84c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.21v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.21,104.28c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.01,103.71c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.3c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.82,103.15c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.21-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.62,102.59c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.43,102.02c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.16,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.24,101.46c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.04,106.12v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.07,.01,.11v3.34c0,.16,0,.25,0,.27-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.96,106.15c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.43,105.91c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M106.61,105.09c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.61,97.72c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M97.02,102.55l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.02,102.17l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.68,119.67c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.81,1.53-.49,4.61-1.88,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.01,110.77c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.46,111.54c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.31,112.15c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.17,112.76c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.03,113.37c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.89,113.98c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.18-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.75,114.59c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.61,115.2c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.47,120.44v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.58,120.76v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.68,121.03v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.78,121.25v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.89,121.42v-5.1c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13,121.56v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.1,121.65v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.2,121.71v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.31,121.74v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.43,121.73v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.56,121.68v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.68,121.6v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.81,121.48v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.93,121.31v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.06,121.11v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.08-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.18,120.85v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.31,120.54v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.11,115.21c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.1,.27,.21v4.87c-.19,.07-.38,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.92,114.65c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.72,114.09c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.53,113.52c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.18,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.34,112.96c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.14,112.4c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.95,111.83c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.48,116.62c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.14,116.28c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.32,115.47c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0s4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M25.32,108.09c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.73,112.92l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.73,112.54l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M26.86,115.72c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.19,106.82c.06,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.64,107.59c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.5,108.2c0-.11,.11-.2,.24-.2h.02c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.35,108.81c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.21,109.42c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.07,110.03c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.7h-.02c-.18-.09-.36-.18-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.93,110.64c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.79,111.25c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.65,116.49v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.76,116.81v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.86,117.08v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.97,117.3v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.07,117.47v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.18,117.6v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.28,117.7v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.39,117.76v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.49,117.79v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.62,117.78v-5.03c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.74,117.73v-5.12c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.87,117.65v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.99,117.52v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.11,117.36v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.24,117.16v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.36,116.9v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.49,116.59v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.29,111.26c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.1,110.7c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.91,110.13c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.3c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.71,109.57c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.18,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.52,109.01c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.32,108.45c0-.11,.11-.2,.24-.2h.02c.15,0,.26,.09,.26,.2v5.39c-.16,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.13,107.88c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.94,112.54v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.15,0,.03,0,.07,.01,.1v3.34c0,.16,0,.26,0,.28-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.86,112.57c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.32,112.33c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.5,111.52c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M24.5,104.14c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.67-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.91,108.97l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.91,108.59l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.18,111.89c-6.14,2.76-16.11,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.81,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.52,102.99c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.96,103.77c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.82,104.38c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.68,104.99c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.54,105.6c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.4,106.21c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.26,106.81c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.12,107.42c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.98,112.67v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.08,112.99v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.19,113.25v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.29,113.47v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.4,113.65v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,113.78v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.61,113.88v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.71,113.94v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.82,113.96v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.94,113.95v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.07,113.91v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.19,113.82v-5.16c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.32,113.7v-5.17c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.44,113.54v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.57,113.33v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.69,113.08v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.82,112.77v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.62,107.44c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.21v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.43,106.87c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.23,106.31c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.04,105.75c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.85,105.19c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.65,104.62c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.46,104.06c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.26,108.71v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.07,.01,.11v3.3c0,.18,0,.29,0,.31-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.18,108.75c-6.14,2.76-16.11,2.76-22.25,0s-6.14-7.24,0-10c6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.65,108.51c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.83,107.69c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M24.83,100.32c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.67,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.14-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.24,105.15l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.24,104.77l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.59,90.7c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.04,91.48c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.42,94.93h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0c0-.1,0-.61,0-1.21,0,.6,0,1.11,0,1.21h0Zm-.17-2.22c-.25-.37-.41-.69-.51-1.05,.04,.13,.09,.26,.15,.39,.09,.21,.2,.42,.34,.62l.03,.04h0Zm-.65-2.03c-.03-.64,0-1.47-.01-2.7,0,.7,0,2.08,.01,2.7h0Zm-.01-3.01v-.07h0v.07h0Zm.33-1.6c0-1.19-.02-1.88,0-2.35v.04c0,.24,0,1.41,0,2.31h0Zm.16-3.67c0-1.11-.04-1.88,0-2.5,0,.1,0,1.51,0,2.5h0Zm.17-3.58c.08-.26,.2-.51,.36-.78-.15,.26-.28,.52-.36,.78h0Zm.48-.97c0-.36,0-.72,0-1.04h0c0,.31,0,.68,0,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.7,95.98c-.15-.35-.25-.7-.28-1.05h0c0-.11,0-.62,0-1.22,0-.26,0-.53,0-.79,.09,.12,.19,.24,.29,.36v2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.57,97.28c-.2-.22-.38-.45-.53-.68v-2.97l.04,.04c.11,.11,.23,.21,.35,.31,.04,.05,.09,.1,.14,.15v3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.91,83.74v-.04h0v.02h0v.02h0Zm.02-.35c.02-.28,.07-.49,.15-.75,0,.11,0,.22,0,.31-.08,.11-.13,.25-.16,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.37,82.73v-1.5c.09,.21,.21,.42,.34,.62v.79c-.13,.02-.24,.05-.34,.09h0Zm.87-.15v-.05s.03,.03,.05,.05h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.28,82.58s-.03-.03-.05-.05v-1.11c.09,.18,.2,.35,.33,.53v.61c-.1,0-.19,.02-.29,.02h0Zm-.57-.73c-.13-.21-.25-.41-.34-.62v-1.96c0-.07-.04-.13-.11-.16-.07,.09-.12,.2-.15,.34,.03-.23,.07-.44,.14-.65,.09-.26,.21-.52,.36-.78,.04-.06,.08-.12,.12-.18h0c0,.77,0,1.5,.01,1.54,.01,.12,.03,.23,.05,.35-.05,.04-.09,.09-.09,.15v1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.1,82.51v-.56c.1,.1,.21,.21,.33,.31v.21c-.11,.02-.22,.03-.33,.05h0Zm-.53-.55c-.13-.17-.24-.35-.33-.53v-.58c.1,.17,.21,.33,.33,.5v.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.97,82.35v-1.26c0-.1-.09-.18-.21-.2v-1.51c.1,.08,.21,.17,.33,.25v2.69s-.08,.02-.12,.03h0Zm-.54-.1c-.11-.1-.22-.2-.33-.31v-1.46c0-.1-.09-.18-.21-.2v-1.7c.1,.11,.21,.23,.33,.34v3.14c.07,.06,.13,.13,.2,.19h0Zm1.41-.15v-.39c0-.1-.09-.18-.21-.2v-1.5c.1,.07,.21,.13,.32,.19v1.87s-.07,.03-.11,.04h0Zm.66-.64v-.97c.06,.03,.13,.07,.2,.1-.05,.18-.12,.48-.2,.87h0Zm-2.92-.13c-.12-.16-.23-.33-.33-.5v-.96c0-.1-.09-.18-.21-.2v-2.4c.09,.21,.2,.42,.34,.62v3.14c.06,.1,.13,.19,.2,.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.68,107.95c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.88,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.01,99.05c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.46,99.83c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.31,100.43c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.17,101.04c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.03,101.65c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.89,102.26c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.18-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.75,102.87c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.61,103.48c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.47,108.72v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.58,109.05v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.68,109.31v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.78,109.53v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.89,109.7v-5.1c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13,109.84v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.1,109.93v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.2,109.99v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.31,110.02v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.43,110.01v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.56,109.96v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.68,109.88v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.81,109.76v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.93,109.59v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.06,109.39v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.18,109.13v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.31,108.83v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.11,103.49c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.1,.27,.21v4.87c-.19,.07-.38,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.92,102.93c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.72,102.37c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.53,101.81c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.18,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.34,101.24c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.14,100.68c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.95,100.12c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.48,104.9c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.14,104.57c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.32,103.75c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0s4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M25.32,96.37c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.73,101.2l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.73,100.82l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M26.86,104c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.19,95.1c.06,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.64,95.87c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.5,96.48c0-.11,.11-.2,.24-.2h.02c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.35,97.09c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.21,97.7c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.07,98.31c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.7h-.02c-.18-.09-.36-.18-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.93,98.92c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.79,99.53c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.65,104.77v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.76,105.09v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.86,105.36v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.97,105.58v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.07,105.75v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.18,105.89v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.28,105.98v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.39,106.04v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.49,106.07v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.62,106.06v-5.03c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.74,106.01v-5.12c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.87,105.93v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.99,105.81v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.11,105.64v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.24,105.44v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.36,105.18v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.49,104.87v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.29,99.54c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.21v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.1,98.98c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.91,98.42c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.3c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.71,97.85c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.18,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.52,97.29c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.32,96.73c0-.11,.11-.2,.24-.2h.02c.15,0,.26,.09,.26,.2v5.39c-.16,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.13,96.17c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.94,100.82v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.15,0,.03,0,.07,.01,.1v3.34c0,.16,0,.26,0,.28-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.86,100.86c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.32,100.62c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.5,99.8c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M24.5,92.42c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.67-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.91,97.25l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.91,96.87l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.18,100.17c-6.14,2.76-16.11,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.52,91.28c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.96,92.05c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.82,92.66c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.68,93.27c0-.11,.11-.2,.25-.21h.03c.15,0,.26,.09,.26,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.54,93.88c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.4,94.49c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.26,95.1c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.12,95.71c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.98,100.95v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.08,101.27v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.19,101.54v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.29,101.75v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.4,101.93v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,102.06v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.61,102.16v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.71,102.22v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.82,102.24v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.94,102.23v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.07,102.19v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.19,102.1v-5.16c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.32,101.98v-5.17c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.44,101.82v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.57,101.61v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.69,101.36v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.82,101.05v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.62,95.72c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.21v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.43,95.16c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.23,94.59c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.04,94.03c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.85,93.47c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.65,92.9c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.46,92.34c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.26,96.99v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.07,.01,.11v3.3c0,.18,0,.29,0,.31-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.18,97.03c-6.14,2.76-16.11,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.65,96.79c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.83,95.97c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M24.83,88.6c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.67,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.14-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.24,93.43l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.24,93.05l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.35,96.35c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.81,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.68,87.45c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05,0-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.13,88.23c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.99,88.84c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.85,89.45c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.71,90.05c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.56,90.66c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.42,91.27c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.28,91.88c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.14,97.13v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.25,97.45v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.35,97.71v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.46,97.93v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.56,98.1v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.67,98.24v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.77,98.34v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.88,98.4v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.98,98.42v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.11,98.41v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.23,98.36v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.36,98.28v-5.16c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.48,98.16v-5.17c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.6,98v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.73,97.79v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.85,97.54v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.98,97.23v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.78,91.9c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.38,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.59,91.33c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.4,90.77c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.2,90.21c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.01,89.64c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.82,89.08c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.62,88.52c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.43,93.17v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.03,0,.07,.01,.11v3.33c0,.16,0,.26,0,.28-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.35,93.21c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.81,92.97c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.99,92.15c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M24.99,84.77c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.67-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.41,89.61l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.41,89.23l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M28,92.4c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68,0-.1-.02-3.35-.02-3.45,0-1.82,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.34,83.5c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.78,84.28c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.64,84.88c0-.11,.11-.2,.24-.2h.03c.15,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.5,85.49c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.36,86.1c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.22,86.71c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.08,87.32c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.94,87.93c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.8,93.17v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.9,93.5v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.01,93.76v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.11,93.98v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.22,94.15v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.32,94.29v-5.11c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.43,94.38v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.53,94.44v-5.01c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.64,94.47v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.76,94.46v-5.03c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.89,94.41v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.01,94.33v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.14,94.21v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.26,94.04v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.38,93.84v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.51,93.58v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.63,93.28v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.44,87.94c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.09,.27,.21v4.87c-.19,.07-.37,.14-.57,.2v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.25,87.38c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.05,86.82c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.29c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.86,86.26c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.66,85.69c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.47,85.13c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.17,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.28,84.57c0-.11,.11-.19,.24-.2h.03c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.08,89.22v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.08,.01,.12v3.29c0,.18,0,.3,0,.31-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,89.26c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.47,89.02c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.65,88.2c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M25.65,80.82c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.06,85.65l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M16.06,85.27l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.36c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.51,88.62c-6.14,2.76-16.1,2.76-22.25,0-2.89-1.3-4.42-2.98-4.59-4.68-.01-.1-.02-3.35-.02-3.45,0-1.81,1.53-.49,4.61-1.87,6.14-2.76,16.1-2.76,22.25,0,3.05,1.37,4.59,.03,4.61,1.82,0,.1,0,3.34-.01,3.44-.14,1.72-1.68,3.42-4.6,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.85,79.72c.07,.04,.11,.1,.11,.16v5.11c-.15-.35-.25-.7-.28-1.05-.01-.1-.02-3.35-.02-3.45,0-.37,.06-.61,.19-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.29,80.49c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.8c-.2-.22-.38-.45-.53-.68v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.15,81.1c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.91s0,.05-.02,.07c-.19-.15-.36-.3-.52-.45v-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.01,81.71c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.9s0,.05-.02,.08c-.18-.12-.36-.23-.52-.35v-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.87,82.32c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.88c-.19-.1-.37-.2-.55-.3v-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.73,82.93c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.69h-.02c-.18-.09-.36-.17-.53-.26v-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.59,83.54c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.45c-.19-.07-.38-.15-.56-.23v-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.45,84.15c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.1,.27,.21v5.15c-.19-.06-.38-.13-.57-.2v-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.31,89.39v-4.63c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.81c-.19-.06-.38-.11-.57-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.41,89.71v-4.83c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.97c-.19-.05-.39-.09-.58-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.52,89.98v-4.97c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v5.09c-.19-.04-.39-.08-.58-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.62,90.2v-5.06c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.15c-.2-.03-.39-.06-.58-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.73,90.37v-5.1c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.18c-.2-.02-.39-.05-.59-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.83,90.51v-5.11c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.17c-.2-.02-.39-.04-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.94,90.6v-5.08c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.12c-.2-.01-.4-.02-.59-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.04,90.66v-5.01c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.03c-.2,0-.4-.01-.6-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.15,90.69v-4.91c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v4.91c-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.27,90.68v-5.03c0-.12,.13-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.01c-.2,0-.4,.01-.6,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.4,90.63v-5.12c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.08c-.2,.01-.39,.03-.59,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.52,90.55v-5.16c0-.12,.12-.22,.28-.22h.04c.15,0,.28,.1,.28,.22v5.11c-.2,.02-.39,.04-.59,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.64,90.43v-5.17c0-.12,.12-.22,.28-.22h.03c.15,0,.28,.1,.28,.22v5.1c-.19,.03-.39,.05-.59,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.77,90.26v-5.14c0-.12,.12-.21,.28-.21h.03c.15,0,.28,.1,.28,.21v5.04c-.19,.04-.39,.07-.58,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.89,90.06v-5.07c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.94c-.19,.04-.38,.09-.58,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.02,89.8v-4.95c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.79c-.19,.05-.38,.1-.58,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.14,89.49v-4.77c0-.12,.12-.21,.27-.21h.03c.15,0,.27,.1,.27,.21v4.59c-.19,.06-.38,.12-.57,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.95,84.16c0-.12,.12-.2,.27-.21h.03c.15,0,.27,.1,.27,.21v4.87c-.19,.07-.37,.14-.57,.21v-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.75,83.6c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.1c-.18,.08-.37,.16-.56,.23v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.56,83.04c0-.11,.12-.2,.26-.21h.03c.15,0,.27,.09,.27,.21v5.3c-.18,.09-.36,.18-.55,.26v-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.37,82.47c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.42c-.17,.1-.36,.2-.55,.3v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.17,81.91c0-.11,.11-.2,.25-.21h.03c.15,0,.27,.09,.27,.21v5.47c-.17,.12-.35,.24-.54,.36v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.98,81.35c0-.11,.11-.2,.24-.2h.03c.14,0,.26,.09,.26,.2v5.39c-.16,.15-.34,.3-.53,.45v-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.78,80.79c0-.11,.11-.19,.24-.2h.02c.14,0,.26,.09,.26,.2v5.07c-.15,.21-.33,.41-.53,.61v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.59,85.44v-5.22c0-.11,.12-.2,.26-.2,.12,0,.22,.06,.25,.14,0,.04,0,.07,.01,.11v3.34c0,.16,0,.25,0,.27-.04,.52-.22,1.04-.52,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.51,85.48c-6.14,2.76-16.1,2.76-22.25,0-6.14-2.76-6.14-7.24,0-10,6.14-2.76,16.1-2.76,22.25,0,6.14,2.76,6.14,7.24,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.98,85.24c-5.85,2.63-15.33,2.63-21.18,0-5.85-2.63-5.85-6.89,0-9.52,5.85-2.63,15.33-2.63,21.18,0,5.85,2.63,5.85,6.89,0,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M25.16,84.42c-4.84,2.18-12.7,2.18-17.54,0-4.84-2.18-4.84-5.71,0-7.88,4.84-2.18,12.7-2.18,17.54,0,4.84,2.18,4.84,5.71,0,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.16,77.04c-4.84-2.18-12.7-2.18-17.54,0-2.28,1.02-3.48,2.35-3.62,3.69,.13,1.34,1.34,2.66,3.62,3.69,4.84,2.18,12.7,2.18,17.54,0,2.28-1.02,3.48-2.35,3.62-3.69-.13-1.34-1.34-2.66-3.62-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M15.57,81.87l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.86,.03c.1,.04,.04,.41,.04,.47,0,.06-.05,.12-.15,.17l-.54,.24c.59,.32,1.06,.61,1.35,.98,.4,.5-.39,1.08-1.56,1.14-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.11-.05-.17-.12-.17-.18s-.05-.42,.07-.47l.6,.07c-1-.45-1.68-1.03-2.01-1.59-.05-.08-.07-.39-.06-.47,.05-.37,.71-.48,1.59-.52,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.57,81.49l-2.33,1.05c1.51,.4,3.17-.25,2.33-1.05h0Zm1.7-2.09l2.21-.99c-1.57-.34-2.91,.33-2.21,.99h0Zm5.91-2.31l.75,.34c.2,.09,.2,.24,0,.33l-.54,.24c.59,.32,1.03,.66,1.32,1.03,.4,.5-.36,1.03-1.53,1.09-.9,.04-1.75-.22-1.97-.61-.09-.16-.2-.29-.32-.4l-2.59,1.17c1.59,1.34,1.44,2.43-.44,3.27-1.99,.89-4.56,.89-7.1,.1l-.51,.23c-.22,.1-.59,.1-.81,0l-.65-.29c-.22-.1-.22-.26,0-.36l.5-.22c-1-.45-1.68-1.03-2.01-1.59-.28-.47,.46-.94,1.54-.99,.91-.05,1.74,.23,1.94,.63,.16,.32,.45,.62,.86,.9l3.01-1.35c-3.55-2.67,2.82-5.09,7.29-3.26l.52-.23c.2-.09,.53-.09,.74,0Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M94.48,60.61c2.05-1.07,4.62-1.18,6.26-1.22,1.63,.77,2.06,3.25,1.49,6.54,2.89,5.14,.48,14.06-2.97,8.27-1.44-4.22-1.78-6.53-4.93-8.39,.05-1.73,.1-3.47,.15-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M30.33,64.21c-.97,2.1-2.95,3.75-4.23,4.77-1.76,.38-3.61-1.32-5.16-4.29-5.42-2.33-8.94-10.87-2.67-8.37,3.71,2.48,5.38,4.1,9.01,3.66,1.01,1.41,2.03,2.82,3.04,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.61,20.78c4.38,2.76,4.41,13.23-3.87,8.56-2.83-1.6-3.47-3.04-2.82-6.24,.29-1.41,3.35-4.2,5.29-3.4,.34,.14,1.17,.94,1.4,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M46.62,12.59c-.89,2.06-3.05,1.71-2.5,5.76,.29,2.12-1.86,2.94-3.17,3.97-2.28,1.79-.11,4.99,2.59,5.36,1.58,.22,5.71,.36,6.28-1.69,.13-.48,1.04-2.48,.73-3.14-.61-1.29,.11-.27-1.12-1.51-2.31-2.32-1.93-3.18-2.14-6.13-.02-.32-.74-2.45-.66-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.45,26.51c-4.1-1.15-7.97-2.53-11.51-4.23-3.51-1.68-6.7-3.69-9.48-6.1l-2.41,2.77c3.05,2.64,6.51,4.82,10.3,6.64,3.75,1.8,7.82,3.25,12.11,4.45l.99-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.14,25.33c-1-.43-5.88-.24-8.16-1.32-1.58,2.69,1.12,6.62,3.48,8.29,.79,.11,2.84,1.45,3.49,.4,.92-1.47,.3-6.26,1.19-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M61.91,52.1c-7.9-1.99-15.47-3.08-22.16-1.8-4.53,1.89-2.49,4.19,3.8,6.76,5.78,3.43,11.98,4.2,18.62,2.13-.09-2.36-.17-4.72-.26-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M38.74,50.9c-3.69,1.92-7.7,4.6-12.41,8.92-.3,2.49,1.08,4.11,4.01,4.94,6.1-1.48,9.73-5,13.65-8.29-1.75-1.85-3.5-3.71-5.25-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.36,30.63c2.23,1.55,4.49,2.95,6.78,4.16,3.45,1.82,6.97,3.19,10.58,3.99l-.81,3.6c-3.94-.87-7.77-2.36-11.49-4.33-2.72-1.43-5.39-3.12-8.03-5.01,.26-.11,.55-.25,.88-.44,.88-.49,1.56-1.17,2.09-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M52.68,52.01c.06,3.49,21.05,19.33,23.86,19.73,3.07-.26,2.72-2.51,1.29-6.02-2.92-5.61-5.5-11.73-9.54-16.04-3.23,1.04-12.38,1.29-15.6,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M76.4,65.11c6.18-.97,12.36-2.84,18.54-5.07,.83,1.98,1.82,3.92-.47,6.63-6.69,2.65-12.78,4.51-17.66,4.8-2.86-.73-3.77-4.74-.41-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.1,27.79c3.68-1.99,7.45-2.24,11.37,.57,1.6,1.15,1.99,1.5,1.52,3.59-.54,2.39-2.54,3.91-4.98,5.18-2.38-.96-4.57-3.13-6.61-6.37-.43-.99-.86-1.98-1.3-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.46,25.04c-1.57-.18-2.01,.94-2.23,2.22-.41,2.28-.65,2.61-1.46,4.67-1.94,4.96,1.37,3.87,3.17,11.73,1.36,5.93,1.09,6.7,1.39,8.36,6.33,3.66,18.32,2.51,20.31-1.84-4-3.71-9.14-12.85-9.43-16.96-.81-.35-3.39-7.28-4.2-7.63-2.24-.96-5.32,.42-7.56-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M53.3,21.98c-.17,2.31,.38,4.2,2.62,5.11,1.03,.42,1.27,.18-.04,1.06-2.1,1.4-4.38,1.71-7.01-.34-.94-.73-.72-.47,0-.89,1.25-.74,1.56-2.22,.9-4.46,1.18-.16,2.35-.32,3.53-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.59,2.68c-1.64-.1-6.18,5.1-7.13,6.67-2,3.28-2.77,11.38,1.7,13.77,2.32,1.24,5.29,.53,7.25-1.1,1.26-1.05,1.81-2.46,2.73-4.58,1.64-3.79,1.99-4.56,1.56-8.55-.35-3.25-.86-4.24-4.24-5.91-.98-.49-1.67-.28-1.87-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M50.74,5.42c2.8-1.35,5.78,1.93,6.6,3.68,.51,1.07,.61,1.96,.59,2.74-.06,2.15-2.54,2.75-3.11,5.32-.32,4.06,1.35,2.82,.43,6.92-1.1,4.9,2.51,7.04,5.81,7.69,2.1,.38,4.43-.18,6.31-.95,6.39-2.61,2.74-2.1,.75-4.06-1.82-1.79-2.55-4.61-.68-7.41,1.38-2.07,2.5-6.55,2.25-8.46C68.13-.81,54.59-1.52,53.4,1.55c-.22,.57-3.72,4.07-2.66,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M54.98,.32c-.54,.24-3.81,.84-4.68,2.78-1.14,2.52-3.75,.64-4.06,4.81-.05,.69,.25,2.1,.5,2.78,.01,.04,.03,.08,.05,.11,.2-.56,.43-1.05,.67-1.46,.8-1.32,4.14-5.2,6.16-6.35,.37-.64,1.01-1.09,.7-1.68-.04-.07,.65-.93,.66-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.14,16.27c.79,1.81,3.42,1.45,3.25,1.48-.9,.18-1.45,3.71-2.72,2.92-.8-.5-.45-4.37-.53-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M50.12,13.75c.09-.09,.09-.24,0-.32-.09-.09-.24-.09-.32,0l-.18,.18c-.45,.47-.53,.55-1.6,.44-.11-.01-.2,.02-.28,.09-.09,.08-.15,.21-.16,.36-.01,.13,0,.28,.04,.44,.1,.39,.38,.87,.93,1.23l.11,.1c.09,.09,.18,.16,.29,.17,.13,0,.23-.09,.24-.22,0-.13-.09-.23-.22-.24-.05,0,.02-.02,0-.05-.05-.05-.11-.1-.17-.14-.44-.29-.66-.67-.74-.97-.03-.11-.04-.21-.03-.28v-.04c1.23,.12,1.34,0,1.91-.59l.18-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M53.62,12.72c-.26-.08-.59,.26-.73,.74-.15,.49-.06,.95,.19,1.03,.26,.08,.59-.26,.73-.74,.15-.49,.06-.95-.19-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M48.65,10.85c-.19-.07-.47,.23-.62,.66-.15,.43-.12,.83,.07,.9,.19,.07,.47-.23,.62-.66,.15-.43,.12-.83-.07-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M54.62,12.42c0,.1,.08,.17,.18,.17,.1,0,.17-.08,.17-.18,0-.23-.07-.45-.19-.65-.13-.21-.3-.4-.5-.56-.08-.06-.19-.04-.25,.03-.06,.08-.04,.19,.03,.24,.17,.13,.31,.28,.41,.45,.08,.14,.14,.3,.14,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M49.46,9.63c.09,.03,.19-.03,.21-.12,.03-.09-.03-.19-.12-.21-.17-.05-.35-.07-.53-.05-.17,.01-.35,.05-.51,.12-.09,.04-.13,.14-.09,.23,.04,.09,.14,.13,.23,.09,.12-.05,.25-.08,.39-.09,.14,0,.28,0,.41,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M54.15,13.25c.06-.02,.1-.08,.08-.15s-.08-.1-.15-.08l-.36,.11c-.06,.02-.1,.08-.08,.15,.02,.06,.08,.1,.15,.08l.36-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M54.15,13.25c.06-.02,.1-.08,.08-.15s-.08-.1-.15-.08l-.36,.11c-.06,.02-.1,.08-.08,.15,.02,.06,.08,.1,.15,.08l.36-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M48.09,10.85s-.01-.11,.04-.14c.05-.03,.11-.01,.14,.04l.17,.29s.01,.11-.04,.14c-.05,.03-.11,.01-.14-.04l-.17-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M54,12.91s.04-.12-.01-.16c-.05-.04-.12-.04-.16,.01l-.25,.29s-.04,.12,.01,.16c.05,.04,.12,.04,.16-.01l.25-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M48.4,10.71c0-.06,.05-.1,.11-.1,.06,0,.1,.05,.1,.11v.34c-.01,.06-.06,.1-.12,.1-.06,0-.1-.05-.1-.11v-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.1,38.65c1.94,.38,4.28,.36,6.5,.45-.65,1.83-1.29,3.67-1.94,5.51-1.63-.92-3.14-1.9-5.44-2.48,.29-1.16,.58-2.32,.88-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.21,32.54c-1.27,5.35-2.85,10.32-4.93,14.7,3.7,.97,7,2.3,9.89,3.99,2.24-4.44,3.65-9.55,4.6-15.03-2.95-1.96-6.2-2.99-9.56-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M88.23,39.28c.95,.65,1.93,1.27,2.99,1.77,1.64,.68,1.34,1.92-1.44,1.42-1.15-.34-2.25-.98-3.34-1.73,.59-.49,1.19-.97,1.78-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.99,16.75c-1.35-1.95-2.18-4.8-3.14-7.42-1.16-2.67-3.97-2-3.08,1.69,.19,1.78,.6,3.5,1.13,5.19-.99-.31-.98-.5-1.98-.81-1.94-.76-1.93,1.24-.32,2.04,1.77,1.16,3.3,1.34,5.77,2.46,.54-1.05,1.08-2.1,1.62-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M79.84,24.33c-.2,4.53,1.37,7.75,4.65,9.7,1.76-1.77,3.84-3.16,6.35-4.03-3.02-1.76-4.04-4.92-4.03-8.79-2.33,.2-4.65,1.41-6.98,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M98.96,16.95c-1.9,3.46-3.87,6.83-7.6,7.55,1.72,1.31,3.44,2.61,5.16,3.91,2.51,.56,4.83-2.3,7.03-7.49-1.53-1.32-3.06-2.65-4.6-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M57.85,32.87c.99,1.02,2,2.2,3.03,3.09,.16,.79,1.56,3.68,1.88,4.42-1.73-1.51-4.03-5.56-4.91-7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M100.04,59.41c.25,0,.49-.02,.71-.02,1.63,.77,2.06,3.25,1.49,6.54,2.39,4.26,1.15,11.12-1.31,10.04,1.39-2.73,1.71-5.86,.05-9.72,.41-2.68,.46-5.16-.93-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.39,68.75l-.29,.23c-1.76,.38-3.61-1.32-5.16-4.29-4.01-1.72-6.97-6.84-5.71-8.38,.62,3.08,2.64,5.63,6.46,7.6,1.37,2.3,2.59,4.38,4.7,4.83Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrar);
export default __webpack_public_path__ + "static/media/registrar.6b99fd3d922a63e81b06a695c3d9b685.svg";
export { ForwardRef as ReactComponent };